import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Hero from "@/components/marketing/Hero";
import EditorialMarquee from "@/components/marketing/EditorialMarquee";
import Services from "@/components/marketing/Services";
import Manifesto from "@/components/marketing/Manifesto";
import Certifications from "@/components/marketing/Certifications";
import Impact from "@/components/marketing/Impact";
import QuoteSection from "@/components/marketing/QuoteSection";
import useSeo from "@/lib/useSeo";

export default function Home() {
  useSeo({
    title: "ENVIROTEK LLC FZ — Certified IT Asset Disposition & Data Destruction",
    description:
      "ENVIROTEK LLC FZ provides certified IT asset disposition in Dubai: secure data destruction (NIST 800-88), datacenter decommissioning, e-waste recycling (R2v3), IT buyback, remarketing and secure logistics.",
    path: "/",
  });
  return (
    <div className="bg-background min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <EditorialMarquee />
        <Services />
        <Manifesto />
        <Certifications />
        <Impact />
        <QuoteSection />
      </main>
      <Footer />
    </div>
  );
}
